import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getCurrentOrganization = state => state.currentOrganization;

export const getCurrentOrganizationId = createSelector(
  [getCurrentOrganization],
  currentOrganization => get(currentOrganization, 'info.customerId'),
);
export const getCompanyName = createSelector(
  [getCurrentOrganization],
  currentOrganization => get(currentOrganization, 'info.name'),
);
export const getCompanyLogoUrl = createSelector(
  [getCurrentOrganization],
  currentOrganization => get(currentOrganization, 'companyLogoUrl'),
);

export const getSites = state => state.sites;
export const getRoles = state => state.roles;
export const getPersonPropertyDefinitions = state =>
  state.personPropertyDefinitions;

export const isUserCountAndQuotaLoading = state =>
  state.currentOrganization.isUserCountAndQuotaLoading;

export const isSamlEnabled = state =>
  state.currentOrganization?.info?.samlEnabled;
